import React from 'react';
import { DataList } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import { columnConfigs } from './listConfig';
import useService from './useService';

const Coupons: React.FC<{}> = () => {
	const { getCouponsData } = useService();

	return (
		<DataList
			fetchData={getCouponsData}
			columnConfigs={columnConfigs}
			hideActions
			rowHeight={50}
			entity={LIST_ENTITY_NAMES.COUPONS}
		/>
	);
};

export default Coupons;
